import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Wave 2 — Input variants aligned to design tokens.
// default → normal field, subtle border, cyan ring on focus
// error   → red border + ring, reserved for form validation feedback
// The `disabled` state is driven by the native attribute, not a variant
//   (`disabled:opacity-50 disabled:cursor-not-allowed`).
const inputVariants = cva(
  "flex h-9 w-full rounded-md border bg-transparent px-3 py-1 text-sm text-foreground shadow-sm transition-colors duration-fast ease-smooth file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-foreground-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
  {
    variants: {
      variant: {
        default: "border-subtle focus-visible:ring-border-focus focus-visible:border-border-focus",
        error:   "border-status-error focus-visible:ring-status-error focus-visible:border-status-error",
      },
    },
    defaultVariants: { variant: "default" },
  }
)

const Input = React.forwardRef(({ className, type, variant, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputVariants({ variant }), className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input, inputVariants }
